import { Empty } from '../Common/Empty'
import type { GoogleBusinessDraft, PostType, ProfilePreview } from '../types'
import { GoogleBusinessPost } from './components/Post'
import { PostPreviewCard } from '../Common/styles'

import styles from './GoogleBusinessPreview.module.css'

import type { JSX } from 'react'

export const GoogleBusinessPreview = ({
  draft,
  profile,
}: {
  draft: GoogleBusinessDraft
  profile: ProfilePreview
}): JSX.Element => {
  if (draft.isEmpty) return <Empty />

  const draftGoogleBusiness: PostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  return (
    <PostPreviewCard
      data-testid="googlebusiness-preview"
      className={styles.googleBusinessPreview}
    >
      <GoogleBusinessPost
        content={draftGoogleBusiness.content}
        profile={profile}
      />
    </PostPreviewCard>
  )
}
